import { Skeleton } from 'antd';
export function LoadingIndicator() {
  return (
    <>
      <Skeleton title paragraph={{ rows: 1 }} active />
      <Skeleton title paragraph={{ rows: 1 }} active />
    </>
  );
}
